export default "__VITE_ASSET__CsMvizrr__"